export default {
  reportTokenState(state) {
    return state.token;
  },
  reportDataState(state) {
    return state.data || {};
  },
  reportLoadingState(state) {
    return state.loading;
  },
};
